export const SCOPE = 'bbraunBavReportingUiReportEditor';
